import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    title: "",
    description: "",
    descriptionFull: "",
    extraParams: {},
    image1: null,
    image2: null,
    form: {
      index: 0,
      maxIndex: 4,
      schedaProdottoPdfUrl: "",
      cgfUrl: "",
      notaInfUrl: "",
      values: {
        // step 1
        Email: null,
        EmailRepeat: null,
        Nome: null,
        Cog_RagSoc: null,
        Privacy: null,
        Tel: null,
        Cell: null,

        // step 2
        Consumo: null,
        IndirizzoSpedizioneBolletta: null,
        Nom_Recap: null,
        Top_Recap: null,
        Via_Recap: null,
        Civ_Recap: null,
        Suf_Recap: null,
        Cap_Recap: null,
        Com_Recap: null,
        Prov_Recap: null,
        Forn_Attuale: null,
        Prelievo: null,
        PrelievoTipi: null,
        Provenienza: null,
        Pod_Pdr: null,
        Potenza: null,
        SedeLegaleFornitura: null,
        Via_Res: null,
        Civ_Res: null,
        Com_Res: null,
        Prov_Res: null,
        Suf_Res: null,
        ResidenzaAnagrafica: null,
        Top_Res: null,
        Cap_Res: null,
        Ind_Forn: null,
        Civ_Forn: null,
        Com_Forn: null,
        Prov_Forn: null,
        Suf_Forn: null,
        Top_Forn: null,
        Cap_Forn: null,

        // step 3
        Nome_Iban: null,
        Cognome_Iban: null,
        CodFiscale_Iban: null,
        TitolaritàConto: null,
        Paperless: null,
        Iban: null,
        CF: null,
        End_Doc: null,
        Num_Doc: null,
        Tipo_Doc: null,
        Documenti: null,
        MetodoPagamento: null,
        PIVA: null,

        // step 4
        Lead: null,
        Data_Ricontatto_Date: null,
        Ora_Ricontatto: null,
        SchedaProdotto: null,
        CondizioniGeneraliFornitura: null,
        NotaInformativa: null,
        InformativaPrivacy: null,
        TrattamentoDati1: null,
        TrattamentoDati2: null,
        TrattamentoDati3: null,
        TrattamentoDati4: null,

        // hidden fields
        Tensione: null,
        Prodotto: null,
        Tipo_Processo: "CAMBIO PRODOTTO",
        Campagna: null,
        Tipo_Ana: null,
        Ene_Rinn: null,
        Tservizio: null,
        Ttariffa: null,
        UserRv: null
      },
      type: null,
      types: ["ee-dom", "ee-au", "gas-dom", "gas-au"]
    },
    paperlessRequired: false,
    provinces: [],
    saveAndRedirectUrl: "https://www.agsmperte.it",
    sendBill: {
      display: "hidden"
    },
    strings: {
      cliccaPerCaricare: "clicca per caricare",
      cuu: "Codice univoco fattura elettronica",
      obbligatorio: "obbligatorio",
      concludi: "concludi",
      data_Ricontatto: "Data ricontatto",
      ora_Ricontatto: "Ora ricontatto",
      schedaProdotto: "Scheda prodotto",
      condizioniGeneraliFornitura: "Condizioni generali di fornitura",
      presaVisione: "Dichiaro di aver preso visione e accetto.",
      nomeIban: "nome intestatario conto",
      nomeIbanAu: "nome delegato conto",
      cognomeIban: "cognome intestatario conto",
      cognomeIbanAu: "cognome delegato conto",
      codFiscaleIban: "codice fiscale intestatario conto",
      codFiscaleIbanAu: "codice fiscale delegato conto",
      titolaritàConto: "titolarità conto",
      accountLabel:
        "Il titolare del conto corrente è lo stesso della fornitura.",
      indirizzo: "indirizzo",
      via_Recap: "indirizzo",
      consumo: "consumo annuo",
      indirizzoSpedizioneBolletta:
        "Indirizzo spedizione bolletta uguale a indirizzo di fornitura",
      nom_Recap: "c/o presso",
      businessName: "ragione sociale",
      //callMeButton: 'fatti aiutare, chiamaci subito',
      callMeButton: "fatti aiutare, chiama il 0452212123",
      numeroCivico: "numero civico",
      copiaIndirizzoResidenza: "Copia indirizzo di residenza",
      conditionsButton: "condizioni contrattuali",
      contractAcceptance: "accettazione del contratto",
      forn_Attuale: "attuale fornitore",
      indirizzoRecapitoBolletta: "Indirizzo di recapito bolletta",
      paperless: "bolletta digitale",
      paperlessLabel:
        "Desidero ricevere la bolletta digitale per questa offerta.",
      paperlessInfo:
        "Questa offerta prevede fatturazione mensile e invio di bolletta digitale.",
      pec: "PEC",
      notaInformativa: "Nota informativa",
      scadenzaDocumento: "scadenza documento",
      end_Doc: "scadenza documento",
      numeroDocumento: "numero di documento",
      num_Doc: "numero di documento",
      documento: "documento",
      tipo_Doc: "documento",
      documenti: {
        CI: "Carta d'Identità",
        PAT: "Patente",
        PASS: "Passaporto"
      },
      fieldError: "Il valore del campo è errato.",
      nome: "nome",
      cognome: "cognome",
      cog_RagSoc: "cognome",
      cog_RagSocAu: "ragione sociale",
      email: "email",
      emailRipeti: "ripeti email",
      tel: "telefono",
      cell: "telefono cellulare",
      gasUsageYear: "consumo annuo",
      prelievo: "Profilo Prelievo",
      prelievoC1: "Riscaldamento",
      prelievoC2: "Uso cottura cibi e/o produzione di acqua calda sanitaria",
      prelievoC3:
        "Riscaldamento + uso cottura cibi e/o produzione di acqua calda sanitaria",
      prelievoC4: "Uso condizionamento",
      prelievoC5: "Uso Condizionamento + riscaldamento",
      prelievoT1: "Uso tecnologico (artigianale-industriale)",
      prelievoT2: "Uso tecnologico + riscaldamento",
      generalConditions: "Condizioni generali",
      iban: "iban",
      provenienza: "mercato di provenienza",
      provenienzaInfo: "hai già aderito a offerte su libero mercato?",
      trattamentoDati1:
        "Acconsento al trattamento dei dati personali per finalità contrattuali e legali",
      trattamentoDati2:
        "Acconsento al trattamento dei dati personali per indagini di mercato e sulla soddisfazione del cliente",
      trattamentoDati3:
        "Acconsento alla cessione dei dati personali ad altro soggetto esterno al Gruppo AGSM per finalità commerciali e promozionali",
      trattamentoDati4:
        "Acconsento al trattamento dei dati personali per la profilazione delle abitudini di consumo",
      modify: "modifica",
      comune: "comune",
      next: "prosegui",
      no: "no",
      offerName: "Nome Offerta",
      metodoPagamento: "metodo di pagamento",
      metodiPagamento: {
        CC: "Conto Corrente",
        BOL: "Bollettino"
      },
      pdr: "codice pdr",
      pod: "codice pod",
      pod_Pdr: "codice pod",
      privacyAcceptance: "consensi privacy",
      informativaPrivacy: "Informativa privacy",
      privacyNote:
        "Dichiaro di avere preso visione ed appreso i contenuti dell’",
      privacyNoteLink: "informativa",
      productSheet: "Scheda prodotto",
      provincia: "provincia",
      province: [
        "Agrigento",
        "Alessandria",
        "Ancona",
        "Aosta",
        "Arezzo",
        "Ascoli Piceno",
        "Asti",
        "Avellino",
        "Bari",
        "Barletta-Andria-Trani",
        "Belluno",
        "Benevento",
        "Bergamo",
        "Biella",
        "Bologna",
        "Bolzano",
        "Brescia",
        "Brindisi",
        "Cagliari",
        "Caltanissetta",
        "Campobasso",
        "Carbonia-Iglesias",
        "Caserta",
        "Catania",
        "Catanzaro",
        "Chieti",
        "Como",
        "Cosenza",
        "Cremona",
        "Crotone",
        "Cuneo",
        "Enna",
        "Fermo",
        "Ferrara",
        "Firenze",
        "Foggia",
        "Forlì-Cesena",
        "Frosinone",
        "Genova",
        "Gorizia",
        "Grosseto",
        "Imperia",
        "Isernia",
        "La Spezia",
        "L'Aquila",
        "Latina",
        "Lecce",
        "Lecco",
        "Livorno",
        "Lodi",
        "Lucca",
        "Macerata",
        "Mantova",
        "Massa-Carrara",
        "Matera",
        "Messina",
        "Milano",
        "Modena",
        "Monza e della Brianza",
        "Napoli",
        "Novara",
        "Nuoro",
        "Olbia-Tempio",
        "Oristano",
        "Padova",
        "Palermo",
        "Parma",
        "Pavia",
        "Perugia",
        "Pesaro e Urbino",
        "Pescara",
        "Piacenza",
        "Pisa",
        "Pistoia",
        "Pordenone",
        "Potenza",
        "Prato",
        "Ragusa",
        "Ravenna",
        "Reggio Calabria",
        "Reggio Emilia",
        "Rieti",
        "Rimini",
        "Roma",
        "Rovigo",
        "Salerno",
        "Medio Campidano",
        "Sassari",
        "Savona",
        "Siena",
        "Siracusa",
        "Sondrio",
        "Taranto",
        "Teramo",
        "Terni",
        "Torino",
        "Ogliastra",
        "Trapani",
        "Trento",
        "Treviso",
        "Trieste",
        "Udine",
        "Varese",
        "Venezia",
        "Verbano-Cusio-Ossola",
        "Vercelli",
        "Verona",
        "Vibo Valentia",
        "Vicenza",
        "Viterbo"
      ],
      potenza: "potenza",
      sedeLegale: "Sede Legale",
      sedeLegaleFornitura:
        "Indirizzo sede legale uguale a indirizzo di fornitura",
      resident: "residente",
      indirizzoResidenza: "Indirizzo di residenza",
      residentNot: "non residente",
      residenzaAnagrafica: "residenza anagrafica",
      saveAndContinueLater: "salva e continua più tardi",
      select: "Seleziona",
      sendBillSuccess: "Bolletta inviata con successo",
      sendBillSuccessDescription:
        "Ti ricontatteremo nel più breve tempo possibile.",
      sendBillTitle: "Inviaci la tua bolletta",
      sendBillSubtitle:
        "Inserisci i tuoi dati e carica tutte le pagine della tua bolletta per essere ricontattato.",
      sendBillButton: "risparmia tempo e inviaci la tua bolletta",
      submit: "invia",
      suffissoCivico: "Suffisso civico",
      indirizzoFornitura: "Indirizzo di fornitura",
      pIVA: "Partita Iva",
      cF: "Codice Fiscale",
      titles: [
        "Dati titolare della fornitura",
        "Informazioni di fornitura",
        "Dati pagamento e fattura",
        "Informazioni contrattuali e consensi",
        "Riepilogo"
      ],
      tipo_Processo: "tipo processo",
      prodotto: "prodotto",
      tensione: "tensione",
      toponimi: [
        "Contrada",
        "Corso",
        "Corte",
        "Galleria",
        "Largo",
        "Lungadige",
        "Località",
        "Piazza",
        "Piazzale",
        "S.P.",
        "S.S.",
        "Strada",
        "Via",
        "Viale",
        "Vicolo",
        "Villaggio"
      ],
      toponimo: "toponimo",
      uploadBills: "carica bollette",
      uploadSuccess: "file caricato",
      sì: "sì",
      cap: "cap",
      privacy:
        "<h4>Informativa sul trattamento dei dati personali ai sensi del Regolamento Europeo 2016/679</h4><h5>1) Finalità del trattamento</h5><p>I dati personali dell’Interessato saranno raccolti e trattati da AGSM Energia S.p.A., sede legale presso Lungadige Galtarossa, 8 - 37133 Verona, PIVA n. 02968430237, titolare del trattamento, tenendo conto di quanto già precisato nelle informative eventualmente rese in precedenza e anche sulla base delle dichiarazioni di volontà espresse, per le seguenti finalità:</p><ol><li>Svolgere in modo adeguato la propria attività inerente il Servizio di Vendita di Energia Elettrica e Gas Naturale incluse le attività ad esso connesse, ossia a titolo esemplificativo: stipula di contratti di fornitura di gas e / o energia elettrica e/o teleriscaldamento, esecuzione dei servizi contrattualmente previsti: fatturazione, gestione amministrativa e organizzazione del rapporto, gestione di eventuali richieste di informazioni, reclami, contenziosi, tutela di AGSM Energia S.p.A.ed eventuale recupero del credito</li><li>In caso di consenso dell’interessato, i dati personali potranno essere raccolti e trattati da AGSM Energia S.p.A. e dalle società facenti parte del Gruppo AGSM per compiere direttamente o tramite società specializzate indagini di mercato o sulla soddisfazione del cliente, mediante interviste personali, telefoniche, questionari e altri mezzi di rilevazione</li><li>In caso di consenso dell’interessato, i dati personali potranno essere raccolti e trattati da AGSM Energia S.p.A. e dalle società facenti parte del Gruppo AGSM, per l’invio di proposte o la vendita diretta relativamente a nuovi servizi e prodotti della società o per migliorare la qualità dei servizi offerti, il tutto con modalità di contatto automatizzate (posta elettronica, telefonate automatizzate, sms od altri servizi di messaggistica o social) e tradizionali(posta cartacea, telefono con operatore)</li><li>In caso di consenso dell’interessato, i dati personali potranno essere comunicati a società terze per l’invio di proposte o la vendita diretta di servizi e prodotti con modalità di contatto automatizzate(posta elettronica, telefonate automatizzate, sms od altri servizi di messaggistica o social) e tradizionali(posta cartacea, telefono con operatore)</li><li>In caso di consenso dell’interessato, i dati personali potranno essere raccolti ed integrati con ulteriori dati da Lei direttamente forniti e trattati anche in forma automatizzata da AGSM Energia S.p.A., per la creazione di profili basati su gusti, preferenze, abitudini, con la finalità di proporre prodotti e servizi personalizzati in base alle Sue esigenze specifiche e per migliorare la qualità dei servizi a Lei offerti dalla società.</li></ol><h5>2) Categoria dei dati raccolti, natura del conferimento dei dati e conseguenze dell’eventuale rifiuto</h5><p>I dati raccolti e trattati da AGSM Energia S.p.A. per assolvere le finalità di cui al paragrafo 1, lett. a) [Finalità contrattuali e legali]sono: dati anagrafici e recapiti del cliente o del delegato indirizzo e caratteristiche tecniche della fornitura informazioni relative al consumo, recapiti per comunicazioni dati di pagamento. I dati raccolti e trattati da AGSM Energia S.p.A.per assolvere le finalità di cui al paragrafo 1, lett.b), c), d) ed e)[Finalità di indagine, marketing, marketing di terzi e profilazione] sono: dati anagrafici e recapiti del cliente altre informazioni relative al cliente o al suo nucleo familiare informazioni relative al consumo energetico informazioni relative alle abitazioni del cliente.</p><p>Il conferimento dei dati personali è obbligatorio ai fini dell’esecuzione del contratto di fornitura di gas e/o energia elettrica e gestione di tutte le attività connesse come specificato al precedente paragrafo 1), lett.a) un eventuale rifiuto dell’interessato nel comunicare i propri dati personali comporta, di fatto, l’impossibilità da parte di AGSM Energia S.p.A.di dare seguito alla richiesta di somministrazione nonché alla conseguente esecuzione dei servizi ed operazioni sottese al contratto.</p><p>La informiamo che le basi giuridiche dei trattamenti di cui al paragrafo 1), lett. a), identificate dal Titolare, sono l’esecuzione di un contratto(o delle misure precontrattuali) di cui l’interessato è parte e l’adempimento di un obbligo legale al quale è soggetto il titolare del trattamento, ai sensi dell’articolo 6, lettera b.e c., del GDPR.</p><p>Il conferimento dei dati per le finalità di cui al paragrafo 1 lett. b), c), d) ed e) [Finalità di indagine, marketing, marketing di terzi e profilazione]è facoltativo e pertanto AGSM Energia S.p.A.provvederà al perseguimento delle finalità solo se espressamente e specificamente autorizzata dall’interessato(tramite consenso) al trattamento dei dati conferiti per ogni singola finalità.Un eventuale rifiuto o il conferimento d’informazioni inesatte e/o incomplete potrebbe impedire di svolgere le suddette attività.</p><p>In ogni caso, l’interessato potrà revocare il consenso prestato in qualsiasi momento senza che questo pregiudichi la liceità del trattamento basata sul consenso espresso prima della revoca.</p><h5>Modalità del trattamento e termini di conservazione dei dati</h5><p>I dati raccolti saranno trattati e conservati sia su supporto cartaceo sia con l’ausilio di strumenti automatizzati secondo logiche strettamente correlate alle finalità sopraindicate e, comunque, in modo da garantire la sicurezza e la riservatezza dei dati per il periodo strettamente necessario a conseguire le finalità per cui sono stati raccolti in ogni caso il criterio utilizzato per determinare tale periodo è improntato al rispetto dei termini consentiti dalle leggi applicabili e dai principi di minimizzazione del trattamento.Per le finalità sopra specificate conserveremo alcuni dati anche dopo la cessazione del rapporto contrattuale per il tempo necessario ad adempimenti contrattuali e di legge.</p><p>I dati raccolti e trattati da AGSM Energia S.p.A. per assolvere le finalità di cui al paragrafo 1, lett. b), c), d) ed e) [Finalità di indagine, marketing, marketing di terzi e profilazione]saranno conservati con le modalità sopra descritte o fin quando l’interessato non richieda la revoca del proprio consenso al perseguimento delle suddette finalità, ad eccezione dei dati raccolti specificamente per finalità di profilazione o di marketing, che verranno conservati rispettivamente per 12 mesi o 24 mesi dalla registrazione conformemente al provvedimento del Garante per la protezione dei dati personali su “&#39 Fidelity card e garanzie per i consumatori” del 24 febbraio 2005.</p><p>Decorso tale periodo i dati saranno cancellati e/o resi anonimi in modo da non permettere, anche indirettamente, di identificare gli interessati.</p><h5>4) Ambito di comunicazione, trasferimento all’estero e diffusione dei dati personali</h5><p>I dati saranno trattati dal personale interno di AGSM Energia S.p.A. in qualità di Incaricati 1 del trattamento. Alcuni trattamenti dei dati potranno altresì essere effettuati, in qualità di Responsabili del trattamento, sia da soggetti previsti dalla legge sia da società del Gruppo od altre Società, anche in outsourcing, che debbano svolgere servizi in favore di AGSM Energia S.p.A.</p><p>Previo consenso libero e specifico dell’interessato, i dati personali forniti potranno, inoltre, essere comunicati a partners commerciali della Società che, agendo come autonomi titolari del trattamento, potranno a loro volta utilizzare i dati personali forniti dall’interessato per le finalità di cui al precedente punto 1, lett.d), relativamente ad iniziative commerciali, promozionali e di marketing di propri beni e/o servizi.</p><p>L’elenco dettagliato ed aggiornato dei Responsabili del trattamento nominati da AGSM Energia S.p.A. è disponibile, su richiesta, inviando una comunicazione all’indirizzo sotto indicato ovvero una e - mail a: dpo@agsmaim.it.</p><p>I dati personali non saranno in alcun modo oggetto di diffusione al pubblico. Qualora si dovesse trasferire i Suoi dati personali al di fuori del territorio dell&#39 Unione Europea, tali trasferimenti saranno coperti con un adeguato livello di protezione.</p><p>Se e quando i Suoi dati dovessero essere trasferiti verso fornitori che risiedono al di fuori del territorio dell&#39Unione Europea, questo trasferimento sarà effettuato sulla base di una decisione di adeguatezza esistente oppure sulla base di un modello di Clausole Contrattuali approvato dalla Commissione Europea.</p><h5>5) Diritti dell’interessato</h5><p>Ai sensi degli articoli da 15 a 22 del Regolamento Europeo 2016/679, l’interessato ha diritto di ottenere dal titolare la rettifica, l’integrazione o la cancellazione(c.d.diritto all’oblio) dei suoi dati personali il diritto di ottenere la limitazione del trattamento e il diritto alla portabilità dei dati, il diritto di opposizione al trattamento dei dati personali, compresa la profilazione ed infine, il diritto di proporre reclamo all’Autorità Garante.Per l&#39 esercizio dei Suoi diritti può rivolgersi al Titolare del trattamento inviando una comunicazione scritta all’indirizzo sotto indicato.</p><h5>6) Titolare e Responsabile del trattamento</h5><p>Titolare del trattamento è AGSM Energia S.p.A., in persona del legale rappresentante, domiciliato presso la sede della società a Verona, Lungadige Galtarossa, 8 - 37133.</p><p>Il Responsabile della Protezione dei Dati personali (RPD) o Data Protection Officer (DPO) è anch’esso domiciliato presso la sede della società.</p><p>Il Responsabile della protezione dei dati potrà essere contattato inviando una comunicazione scritta all’indirizzo sopra indicato(all’attenzione del RPD), oppure a mezzo e - mail a: dpo@agsmaim.it.</p>",
      uploadError: "Nessun file caricato",
      uploadErrorType: "Formato file non corretto",
      uploadErrorSize:
        "Si è verificato un errore durante il caricamento, ridurre il file a meno di 5 megabyte",
      callDate:
        "Scegli la data in cui essere ricontattato tra i 2 e 10 giorni, esclusi festivi e sabato pomeriggio."
    },
    svg: {
      arrowNext:
        '<svg width="24px" height="19px" viewBox="0 0 24 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-236.000000, -11.000000)" fill="#FFFFFF"><path d="M258.290578,21 L236.5,21 C236.22,21 236,20.78 236,20.5 C236,20.22 236.22,20 236.5,20 L258.290578,20 L250.15,11.85 C249.95,11.66 249.95,11.34 250.15,11.15 C250.34,10.95 250.66,10.95 250.85,11.15 L259.791289,20.091289 C259.918377,20.1811598 260,20.3294495 260,20.5 C260,20.6705505 259.918377,20.8188402 259.791289,20.908711 L250.85,29.85 C250.76,29.95 250.63,30 250.5,30 C250.37,30 250.24,29.95 250.15,29.85 C249.95,29.66 249.95,29.34 250.15,29.15 L258.290578,21 Z"></path></g></g></svg>'
    },
    sellers: [],
    token: null
  },
  mutations: {
    extraParams(state, params) {
      if (_.isPlainObject(params)) {
        state.extraParams = params
      }
    },

    formIndex(state, value) {
      if (_.inRange(value, 0, state.form.maxIndex + 1)) {
        state.form.index = value
      }
    },

    formValues(state, params) {
      if (_.isPlainObject(params)) {
        state.form.values = Object.assign({}, state.form.values, params)
      }
    },

    init(state, params) {
      let initValues = {}

      if (params && params.tipo_Processo !== undefined) {
        initValues.Tipo_Processo = params.tipo_Processo
      }
      if (params && params.titolo !== undefined) {
        state.title = params.titolo
      }
      // if (params && params.descrizione !== undefined) {
      //   state.description = params.descrizione
      // }
      if (params && params.descrizione !== undefined) {
        state.description = params.descrizione
      }
      if (params && params.descDettagliata !== undefined) {
        state.descriptionFull = params.descDettagliata
      }
      if (params && params.image1) {
        state.image1 = params.image1
      }
      if (params && params.image2) {
        state.image2 = params.image2
      }
      if (params && params.tServizio !== undefined) {
        initValues.Tservizio = params.tServizio
      }
      if (params && params.tTariffa !== undefined) {
        initValues.Ttariffa = params.tTariffa
      }
      if (
        params &&
        params.tServizio !== undefined &&
        params.tTariffa !== undefined
      ) {
        state.form.type = `${params.tServizio.toLowerCase()}-${
          params.tTariffa.toLowerCase() === "domestico" ? "dom" : "au"
        }`
      }
      if (params && params.campagna !== undefined) {
        initValues.Campagna = params.campagna
      }
      if (params && params.tipo_ana !== undefined) {
        initValues.Tipo_Ana = params.tipo_ana
      }
      if (params && params.ene_Rinn !== undefined) {
        initValues.Ene_Rinn = params.ene_Rinn
      }
      if (params && params.tensione !== undefined) {
        initValues.Tensione = params.tensione
      }
      if (params && params.prodotto !== undefined) {
        initValues.Prodotto = params.prodotto
      }
      if (params && params.kitContrattuale) {
        state.form.schedaProdottoPdfUrl =
          params.kitContrattuale.schedaProdottoPdf
        state.form.cgfUrl = params.kitContrattuale.cgf
        state.form.notaInfUrl = params.kitContrattuale.notaInf
      }
      if (params && params.userRv) {
        initValues.UserRv = params.userRv
      }
      if (["SI", "NO"].includes(params.paperless)) {
        state.paperlessRequired = params.paperless === "SI"
      }

      state.form.values = Object.assign({}, state.form.values, initValues)
    },

    provinces(state, value) {
      if (value && value.length) {
        state.provinces = value
      }
    },

    sendBillDisplay(state, value) {
      if (["hidden", "visible"].includes(value)) {
        state.sendBill.display = value
      }
    },

    sellers(state, values) {
      if (values && values.length) {
        state.sellers = values
      }
    },

    token(state, value) {
      if (typeof value === "string") {
        state.token = value
      }
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js